import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import LoanApplicationList from './LoanApplicationList';

const LoanApplication = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Solicitudes de prestamo' pageTitle='Prestamos' />
                <LoanApplicationList />
            </div>
        </React.Fragment>
    )
}

export default LoanApplication;